<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_5"></a>To my kids, Cole, Mia, and Ella,<br/>in the hopes that they embrace the joys of gardening someday.</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/f0005-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03dedication.vue?f774dbc2